"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatePatronById = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Updates a patron by given ID.
 *
 * Patron is identified by their stringified `ObjectID`.
 *
 * ## Usage
 *
 * ```ts
 * const patronId: string = "5f5e555d5a578b6";
 * const patron: Partial<Patron> = {
 * 	tier: "3"
 * };
 *
 * const {
 * 	acknowledged,
 * 	matchedCount,
 * 	modifiedCount,
 * 	upsertedCount,
 * 	upsertedId,
 * } = await sdk.updatePatronById({ patronId, patron });
 * ```
 *
 * @param params.patronId - ID of the patron to update.
 * @param params.patron   - Fields to update in the patron of given ID.
 */
const updatePatronById = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { patronId, patron } = params;
    const url = `${BASE_URL}/patrons/patron/${patronId}`;
    const response = yield axios_1.default.put(url, patron, { validateStatus: () => true });
    const { status, data } = response;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.updatePatronById = updatePatronById;
